import { InfoRenderer } from '../../../components';
import style from './affiliateCard.module.css';
import UserImageNew from '../userImage/userImageNew';

const AffiliateCardNew = ({
  url = null,
  name = null,
  company = null,
  size = '40px',
  isVerified = false,
  customClass = '',
  email = null,
  phone = null,
  primaryClass = 'text-capitalize',
  affiliateType = 'CONCIERGE',
  showVerifiedIcon = true,
  showAffiliateIcon = true,
}) => {
  return (
    <div className={`row flex-nowrap tw-items-center no-gutters ${customClass}`}>
      <div className={`col-auto`}>
        <UserImageNew
          affiliateType={affiliateType}
          url={url}
          name={name}
          isVerified={isVerified}
          size={size}
          showVerifiedIcon={showVerifiedIcon}
          showAffiliateIcon={showAffiliateIcon}
          verificationStatus={isVerified ? 'verified' : 'unverified'}
        />
      </div>
      <div className={`col ${style.affiliateCardText}`}>
        <div className={`fw-500 d-flex tw-gap-1.5   ${style.affiliateCardName}`}>
          <InfoRenderer content={name} className={primaryClass} />
          {/* {status ? (
            <TooltipProvider>
              <Tooltip>
                <TooltipTrigger className='tw-bg-transparent'>{getStatusIcon(status)}</TooltipTrigger>
                <TooltipContent>{getStatusLabel(status, t)}</TooltipContent>
              </Tooltip>
            </TooltipProvider>
          ) : null} */}
        </div>
        <div className={`dark-grey fw-400`}>
          {email ? (
            <InfoRenderer content={email} />
          ) : (
            <InfoRenderer content={company} className='text-capitalize' />
          )}
        </div>
        {phone ? (
          <InfoRenderer className='dark-grey tw-text-[13px] tw-leading-5' content={phone} />
        ) : null}
      </div>
    </div>
  );
};

export default AffiliateCardNew;
